import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { find } from 'lodash-es';
import {
  UIKitIconRegistry, gbpIcon, searchingIcon, closeIcon, ModalService, AnalyticsService,
} from '@ui-kit';
import { Router } from '@angular/router';
import { ukPhoneRegex } from '../../shared.helpers';
import { AppService } from '../../../app.service';
import { LeanFavourite } from '../../../public/favourites/shortlist.helpers';
import { UserService } from '../../service';

@Component({
  selector: 'app-offer-accepted',
  templateUrl: './offer-accepted.component.html',
  styleUrls: ['./offer-accepted.component.scss'],
})
export class OfferAcceptedComponent implements OnInit {
  @Input() selected: LeanFavourite;

  favourites = this.user.favouritesObservable
    .pipe(
      map((favourites) => favourites
        .filter((favourite) => favourite.canonicalStatus === 'Eligible')
        .map((favourite) => ({
          label: favourite.listing.source_data.address || favourite.listing.source_data.displayable_address,
          value: favourite.id,
        }))),
      map((favourites) => [{ label: 'Select home', value: '' }, ...favourites]),
    );

  propertyTypeOptions = [
    { label: 'Flat', value: 'flat' },
    { label: 'Semi-detached', value: 'semi_detached' },
    { label: 'Detached', value: 'detached' },
    { label: 'Terraced', value: 'terraced' },
  ];

  offerAccepted: FormGroup;

  toggle: Dictionary<boolean> = {};

  constructor(
    private app: AppService,
    private user: UserService,
    private formBuilder: FormBuilder,
    private modal: ModalService,
    private analytics: AnalyticsService,
    private router: Router,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([
      gbpIcon,
      searchingIcon,
      closeIcon,
    ]);
  }

  ngOnInit(): void {
    this.offerAccepted = this.formBuilder.group({
      favourite: [{
        value: this.selected?.id,
        disabled: false,
      }, Validators.compose([Validators.required])],
      price: [{
        value: this.selected?.price || 0,
        disabled: false,
      }, Validators.compose([Validators.required])],
      postcode: [{
        value: this.selected?.postcode || '',
        disabled: false,
      }, Validators.compose([Validators.required])],
      surface_area: [{
        value: this.selected?.surface_area || 0,
        disabled: false,
      }, Validators.compose([Validators.required])],
      property_type: [{
        value: this.selected?.property_type || this.propertyTypeOptions[0].value,
        disabled: false,
      }, Validators.compose([Validators.required])],
      phone: [{
        value: this.user.current.phone,
        disabled: false,
      }, Validators.compose([Validators.required, Validators.pattern(ukPhoneRegex)])],
    });

    this.offerAccepted.valueChanges
      .subscribe(this.valueChanges.bind(this));
  }

  /**
   *
   */
  offerAcceptedSubmit(event: Event): void {
    event.preventDefault();

    const { value } = this.offerAccepted;

    const id = value.favourite;

    // tslint:disable-next-line: variable-name
    const progressTowardsCompletion = {
      ...this.selected.progress_towards_completion,
      property_offer_accepted: true,
    };

    const update = {
      ...value,
      progress_towards_completion: progressTowardsCompletion,
    };

    delete update.favourite;

    this.toggle.working = true;

    this.user
      .updateFavourite(id, update)
      .toPromise()
      .then((updatedFavourite) => this.user
        .updateApplication({ my_home: updatedFavourite.id })
        .toPromise()
        .then(() => {
          this.app.event.emit({ type: 'offer-accepted-confirm' });

          this.analytics.eventTrack({
            data: {
              event: 'http',
              action: 'offer-accepted',
              label: 'success',
              properties: {
                value: '1',
                category: 'app',
                route: this.router.url,
              },
            },
          });
        }))
      .catch(console.log)
      .finally(() => this.toggle.working = false);

    this.modal.open('Congratulations on your offer being accepted! A member of our team will be in touch soon.'
    // + 'Can\'t wait to get things moving? Book a call with us at your convenience,'
    , {
      // ok: 'Book a call',
      cancel: 'Got it',
    }).then((response) => {
      // if (response.action === 'ok') {
      //   this.app.bookCall('proportunity', 'chat-with-us');
      // }
    });
  }

  close(event: MouseEvent | TouchEvent): void {
    this.modal.closeAll();
  }

  /**
   *
   */
  private valueChanges(values): void {
    const existingSelected = this.selected ? { ...this.selected } : this.selected;
    const selected = find(this.user.favourites, { id: values.favourite });

    if (existingSelected?.id !== selected?.id) {
      this.selected = selected;

      this.offerAccepted.patchValue({
        price: selected?.price || 0,
        postcode: selected?.postcode || '',
        surface_area: selected?.surface_area || 0,
        property_type: selected?.property_type || this.propertyTypeOptions[0].value,
      }, { emitEvent: false });
    }
  }
}
